import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchProviderForms(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/provider-forms', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchMe() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/provider-forms/me')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
